/**
 * Defensive JSON parsing for values the app does not control: web storage that
 * another tab or an older build wrote, and payloads arriving over the session
 * channel. Every one of those call sites had grown its own
 * `try { JSON.parse } catch { null }`, so a malformed value was handled four
 * slightly different ways.
 */

/**
 * Parses JSON, answering null instead of throwing on anything unparseable.
 * @param {string|null|undefined} raw - Text to parse; absent input reads as null.
 * @returns {*} The parsed value, or null when `raw` is missing or malformed.
 * @author armandoricosandoval -ai-
 */
export const safeJsonParse = (raw) => {
  if (raw === null || raw === undefined) return null;

  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};
